export const FIELD_PADDING_PX = {
  large: { x: 12, y: 8 },
  medium: { x: 10, y: 6 },
} as const;

export type FieldSize = keyof typeof FIELD_PADDING_PX;

export const FIELD_VALUE_TYPOGRAPHY = {
  large: 'body1',
  medium: 'body2',
} as const satisfies Record<FieldSize, 'body1' | 'body2'>;

export const FIELD_LABEL_TYPOGRAPHY = {
  large: 'subtitle1',
  medium: 'subtitle2',
} as const satisfies Record<FieldSize, 'subtitle1' | 'subtitle2'>;

export const FIELD_LABEL_ASTERISK_GAP_PX = {
  large: 4,
  medium: 2,
} as const satisfies Record<FieldSize, number>;

export const FIELD_STACK_GAP_PX = 4;

export const FIELD_ADORNMENT_GAP_PX = {
  large: 10,
  medium: 8,
} as const satisfies Record<FieldSize, number>;

export const FIELD_ICON_PX = {
  large: 20,
  medium: 16,
} as const satisfies Record<FieldSize, number>;

export const FIELD_RADIUS_PX = 6;

export const FIELD_BORDER_WIDTH_PX = 1;

export const fieldInputPadding = (size: FieldSize) => {
  const { x, y } = FIELD_PADDING_PX[size];

  return { paddingTop: y, paddingRight: x, paddingBottom: y, paddingLeft: x };
};
